module.exports = __webpack_public_path__ + "img/h1-layer2.1c646523.png";